/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_EyebrowInputs */

const tr_cerez_eyebrow = /** @type {(inputs: Cerez_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çerez Politikası`)
};

const en_cerez_eyebrow = /** @type {(inputs: Cerez_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Policy`)
};

const de_cerez_eyebrow = /** @type {(inputs: Cerez_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-Richtlinie`)
};

const ru_cerez_eyebrow = /** @type {(inputs: Cerez_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика в отношении файлов cookie`)
};

/**
* | output |
* | --- |
* | "Cookie Policy" |
*
* @param {Cerez_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_eyebrow = /** @type {((inputs?: Cerez_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_eyebrow(inputs)
	if (locale === "de") return de_cerez_eyebrow(inputs)
	if (locale === "ru") return ru_cerez_eyebrow(inputs)
	return tr_cerez_eyebrow(inputs)
});